/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import ApplicationState        from 'store/application';
import Projections             from 'store/projections';
import { XHR }                 from 'utils/XHR';
import { getListableProjects } from 'utils/getListableProjects';
import GUI                     from 'services/gui';

const LOGO_GIS3W = 'images/logo_gis3w_156_85.png';

/** Cached HTTP GET request */
async function get_macro(id) {
  get_macro[id] = get_macro[id] || await XHR.get({ url: encodeURI(`/${ApplicationState.user.i18n}/about/api/group/${id}/`) });
  return get_macro[id];
}

/** Cached HTTP GET request */
async function get_group(id) {
  get_group[id] = get_group[id] || await XHR.get({ url: encodeURI(`/${ApplicationState.user.i18n}/about/api/group/${id}/projects/`) });
  return get_group[id];
}

const __vue_script__ = {

  /** @since 3.11.0 */
  name: 'modal-changemap',

  data() {
    return {
      
      /** @type { uknown } */
      state:      null,

      /** @type {boolean} */
      loading:    false,

      /** @type { 'projects' | 'groups' | 'root' } */
      current:    'projects',

      /** @type { Array } */
      items:      [],

      /** @type { uknown } */
      parent:     null,

      /** @type { Array } all items from top to bottom */
      steps:      [],

      /** @type { string } ID of a current project group */
      curr_group: null,
 
    }
  },

  methods: {

    /**
     * @returns { Promise<void> }
     */
    async back() {
      const last_step   = this.steps.pop();                               // remove last
      const has_steps   = this.steps.length > 0;
      const item        = has_steps && this.steps[this.steps.length - 1]; // get last step

      // back to macrogrup
      if (
        (has_steps && undefined !== item.macrogroup_id) ||
        (!has_steps && undefined === last_step && Array.isArray(this.parent.macrogroup_id) && this.parent.macrogroup_id.length > 0) // no steps done the first time
      ) {
        const macrogroup_id = has_steps ? item.macrogroup_id : this.parent.macrogroup_id;
        const add           = !has_steps; // false = step it's comping from bottom to top
        return this.showMacroGroups(macrogroup_id, add);
      }

      // back to group
      if (has_steps && undefined === item.macrogroup_id) {
        return this.showGroups(item, false);
      }

      // back to root
      if (!has_steps) {
        return this.showRoot();
      }
    },

    /**
     * @param { Array } macrogroup_id
     * @param { boolean } addStep Boolean
     * 
     * @returns { Promise<void> }
     * 
     * @since 3.10.0
     */
    async showMacroGroups(macrogroup_id = [], addStep = true) {
      // the current project belongs to just one macrogroup
      if (1 === macrogroup_id.length) {
        this.parent = this.macrogroups.find(mg => mg.id === macrogroup_id[0]);
        return await this.showGroups(this.parent);
      }

      // the current project belongs to more than one macrogroup
      this.items   = this.macrogroups.filter(m => macrogroup_id.includes(m.id));
      this.current = 'macrogroups';
      this.parent  = {
        macrogroup_id,
        title: null, // hide title
        name:  null   // hide name
      }

      if (addStep) {
        this.steps.push(this.parent);
      }
    },

    /**
     * @param item
     * @param { boolean } addStep Boolean
     * 
     * @returns { Promise<void> }
     */
    async showGroups(item, addStep = true) {
      try {
        this.loading = true;
        this.parent  = item;
        this.items   = await get_macro(item.id);
        this.current = 'groups';
      } catch(e) {
        console.warn(e);
        this.items = [];
      } finally {
        if (addStep) {
          this.steps.push(this.parent);
        }
        this.loading = false;
      }
    },

    /**
     * @param item
     * 
     * @returns { Promise<void> }
     */
    async showProjects(item) {
      try {
        this.loading = true;
        this.parent  = item;
        this.items   = (
          this.parent.id === this.curr_group
            ? getListableProjects()
            : await get_group(item.id, item => this.setItemImageSrc({ item, type: 'project' }))
        );
        this.current = 'projects';
      } catch(e) {
        console.warn(e);
        this.items = [];
      } finally {
        this.steps.push(this.parent);
        this.loading = false;
      }
    },

    showRoot() {
      this.current = 'root';
      this.items = [...this.macrogroups, ...this.groups];
      this.steps = [];
    },

    /**
     * @param {string} item.url
     * @param {string} item.map_url
     */
    async changeMapProject(item) {
      let url;
      const base_url = window.initConfig.urls.baseurl;
      const epsg     = this.parent.srid ? `EPSG:${this.parent.srid}` : this.parent.crs.epsg;
      await Projections.registerProjection(epsg);
      try {
        new URL(base_url);
        url = `${base_url}${item.url || item.map_url.replace(/^\//, "")}`;
      } catch(e) {
        url = `${location.origin}${base_url}${item.url || item.map_url.replace(/^\//, "")}`;
      }
      url = await GUI.getService('map').addMapExtentUrlParameterToUrl(url, epsg);
      history.replaceState(null, null, url);
      location.replace(url);
    },

    async trigger(item) {
      switch(this.current) {
        case 'root':        return undefined === item.srid ? this.showGroups(item) : this.showProjects(item); // `srid` is undefined when item is a macrogroup
        case 'macrogroups': return this.showGroups(item);
        case 'groups':      return await this.showProjects(item);
        case 'projects':    return await this.changeMapProject(item);
      }
    },

    /**
     * Set scr image of project, group, macrogroup
     * 
     * @param { 'project' | 'group' | 'macrogroup' } image.type
     * @param                                        image.item
      */
    setItemImageSrc({ item, type } = {}) {
      switch(type) {
        case 'project':    item.thumbnail       = this._setSrc(item.thumbnail); break;
        case 'group':      item.header_logo_img = this._setSrc(item.header_logo_img); break;
        case 'macrogroup': item.logo_img        = this._setSrc(item.logo_img); break;
        // Set a fallback image on network error.
        case 'net_error':
          if (item.thumbnail || item.logo_img) {
            item.thumbnail = `${window.initConfig.urls.clienturl}${LOGO_GIS3W}`;
          } else if (item.header_logo_img) {
            item.header_logo_img = `${window.initConfig.urls.clienturl}${LOGO_GIS3W}`;
          }
          break;
      }
    },

    /**
     * @TODO extract as utility function (almost the same as `components/ProjectsMenu::logoSrc(src)`) 
     */
    _setSrc(src) {
      let imageSrc;
      const host       = this.$options.host || '';
      const mediaurl   = window.initConfig.mediaurl;
      const clienturl  = window.initConfig.urls.clienturl;
      const has_media  = src && (src.includes(mediaurl));
      const not_static = src && (!src.includes('static') && !src.includes('media'));

      if (!src) {
        imageSrc = `${clienturl}${LOGO_GIS3W}`;
      } else if (has_media) {
        imageSrc = src;
      } else if (not_static) {  
        imageSrc = `${mediaurl}${src}`;
      } else {
        imageSrc = `${clienturl}${LOGO_GIS3W}`;
      }

      return `${host}${imageSrc}`;
    },

  },

  async created() {

    const config = window.initConfig;

    // setup items data (macrogrups and groups).
    this.items       = getListableProjects();
    this.parent      = window.initConfig;
    this.curr_group  = this.parent.id;
    this.macrogroups = config.macrogroups;
    this.groups      = config.groups;

    // setup items images
    Object
      .entries({ 'project': this.items, 'magrocroup': this.macrogroups, 'group': this.groups })
      .forEach(([type, d]) => d.forEach(item => this.setItemImageSrc({ item, type })))
  },

};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"modal-changemap","tabindex":"-1"}},[_c('div',{staticClass:"modal-dialog",staticStyle:{"min-width":"80vw"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body",staticStyle:{"height":"80vh"}},[('root' !== this.current)?_c('div',{staticClass:"skin-background-color",staticStyle:{"display":"flex","align-items":"center","color":"#fff"}},[_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:bottom",value:('Change Session'),expression:"'Change Session'",arg:"bottom"},{name:"disabled",rawName:"v-disabled",value:(_vm.loading),expression:"loading"}],staticStyle:{"font-size":"2em","margin":"5px","cursor":"pointer","padding":"3px","border":"2px solid #fff","border-radius":"3px"},on:{"click":function($event){$event.stopPropagation();return _vm.back.apply(null, arguments)}}},[_c('i',{class:_vm.$fa('reply'),staticStyle:{"color":"#FFF"}})]),_vm._v(" "),(_vm.parent)?_c('div',{staticStyle:{"margin":"auto"}},[_c('h3',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(_vm.parent.title || _vm.parent.name))])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.items.length)?_c('div',{staticClass:"g3w-change-map-menu-container"},_vm._l((_vm.items),function(item){return _c('div',{key:item.name,staticClass:"menu-item"},[_c('div',{staticClass:"menu-item-image",on:{"click":function($event){$event.stopPropagation();return _vm.trigger(item)}}},[_c('img',{staticClass:"img-responsive",attrs:{"src":item.thumbnail || item.header_logo_img || item.logo_img,"alt":"logo"},on:{"error":function($event){return _vm.setItemImageSrc({ item: item, type: 'net_error' })}}})]),_vm._v(" "),_c('div',{staticClass:"menu-item-content"},[_c('div',{staticClass:"menu-item-text"},[_c('h4',{staticClass:"menu-item-title"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(item.description)}})])])])}),0):_c('h3',{directives:[{name:"t",rawName:"v-t",value:(("no_other_" + _vm.current)),expression:"`no_other_${current}`"}],staticStyle:{"font-weight":"bold"}})]),_vm._v(" "),_c('div',{staticClass:"modal-footer",staticStyle:{"position":"relative","background":"#fff"}},[_c('button',{directives:[{name:"t",rawName:"v-t",value:('close'),expression:"'close'"}],staticClass:"btn btn-default",attrs:{"type":"button","data-dismiss":"modal"}})])])])])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-477c12a2_0", { source: ".g3w-change-map-menu-container[data-v-477c12a2]{height:100%;display:grid;grid-template-columns:repeat(auto-fill,minmax(30%,1fr));grid-gap:1em;overflow-y:auto}.menu-item[data-v-477c12a2]{margin-bottom:20px;margin-top:20px}.menu-item-image[data-v-477c12a2]{cursor:pointer;position:relative;overflow:hidden;padding-bottom:50%;opacity:.7}.menu-item-image[data-v-477c12a2]:hover{opacity:1}.menu-item-image img[data-v-477c12a2]{position:absolute;top:0;bottom:0;left:0;right:0;margin:auto}.menu-item-content[data-v-477c12a2]{padding:15px;background:rgba(255,255,255,.3)}.menu-item-text[data-v-477c12a2]{position:relative;overflow:hidden;height:100%;text-align:justify}.menu-item-title[data-v-477c12a2]{text-align:center;font-weight:700;background:rgba(255,255,255,.5);padding:5px}", map: undefined, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-477c12a2"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "ModalChangeMap.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (true && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__